// <home-hero> — slides crossfade on per-slide durations; the active video restarts from 0, the next one
// preloads; bars fill per duration and jump to a slide on click. Reduced motion: no auto-advance, no video.
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
class HomeHero extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.hs-slide')];
    this.bars = [...this.querySelectorAll('.hero-bars button')];
    this.i = 0;
    this.querySelector('.hero-bars')?.addEventListener('click', (e) => { const b = e.target.closest('[data-go]'); if (b) this.go(+b.dataset.go); });
    this.io = new IntersectionObserver(([en]) => { this.visible = en.isIntersecting; this.visible ? this.play() : this.pause(); }, { threshold: 0.05 });
    this.io.observe(this);
    document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.visible && this.play()));
  }
  disconnectedCallback() { clearTimeout(this.t); this.io?.disconnect(); }
  video(i) { return this.slides[i]?.querySelector('video'); }
  play() {
    if (reduce.matches) return;
    const v = this.video(this.i); if (v) { v.muted = true; v.play().catch(() => {}); }
    const nx = this.video((this.i + 1) % this.slides.length); if (nx && nx.preload === 'none') nx.preload = 'auto';
    this.queue();
  }
  pause() { clearTimeout(this.t); this.slides.forEach((s, k) => { const v = this.video(k); v && !v.paused && v.pause(); }); }
  queue() {
    clearTimeout(this.t);
    if (reduce.matches || this.slides.length < 2) return;
    this.t = setTimeout(() => this.go((this.i + 1) % this.slides.length), +this.slides[this.i].dataset.dur || 5000);
  }
  go(i) {
    if (i === this.i) return;
    const prev = this.i; this.i = i;
    this.slides.forEach((s, k) => { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', String(k !== i)); });
    this.bars.forEach((b, k) => { b.classList.toggle('on', k === i); b.classList.toggle('done', k < i); b.setAttribute('aria-current', String(k === i)); });
    // restart the bar animation of the new slide
    const bar = this.bars[i]?.querySelector('i'); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
    const idx = this.querySelector('[data-idx]'); if (idx) idx.textContent = String(i + 1).padStart(2, '0');
    const v = this.video(i); if (v && !reduce.matches) { v.currentTime = 0; if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); }
    setTimeout(() => { const pv = this.video(prev); if (pv && prev !== this.i) pv.pause(); }, 1700);
    const nx = this.video((i + 1) % this.slides.length); if (nx && nx.preload === 'none') nx.preload = 'metadata';
    if (this.visible) this.queue();
  }
}
if (!customElements.get('home-hero')) customElements.define('home-hero', HomeHero);
